'use strict';

var _ = require('lodash');
var MarketsFilterByCabinFactory = function MarketsFilterByCabinFactory(DataFilter) {
  function MarketsFilterByCabin() {
    DataFilter.call(this, 'market-dashboard', 'cabins', 2);
  }
  MarketsFilterByCabin.prototype = Object.create(DataFilter.prototype);
  MarketsFilterByCabin.prototype.filter = function (data, range) {
    range = range[0];
    return _.isArray(range) ? DataFilter.prototype.filter(data, range, 'cabin') : data;
  };
  return MarketsFilterByCabin;
};
MarketsFilterByCabinFactory.$inject = ['DataFilterFactory'];
module.exports = MarketsFilterByCabinFactory;